import { Stack, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

type MultilineProp = { multiline?: boolean };
const multilineProp = { shouldForwardProp: (prop: PropertyKey) => prop !== 'multiline' };

export const IconTextRowRoot = styled(Stack, multilineProp)<MultilineProp>(
  ({ theme, multiline }) => ({
    '& > .MuiSvgIcon-root': {
      fontSize: 14,
      ...(multiline && { marginTop: theme.spacing(0.2) }),
    },
  }),
);

export const IconTextRowText = styled(Typography, multilineProp)<MultilineProp>(
  ({ multiline }) => ({
    fontSize: '0.7rem',
    ...(multiline && { lineHeight: 1.7, wordBreak: 'break-word' }),
  }),
);
